<template>
  <div id="forgotten" class="row justify-content-md-center">
      <div class="col-12 col-md-6 col-xl-4">
        <h1>Forgotten Password</h1>
        <p>We'll send you an email with a link to reset your password.</p>
            <form v-on:submit.prevent="forgottenSubmit" class="row forgotten-form ct-form">
                <label class="col-12 col-sm-4">Email</label>
                <input name="email" v-model="email" v-focus class="col-12 col-sm-8 form-control">
                <ButtonWithLoading
                type="submit"
                class="mx-auto"
                :state="forgottenState"
                text="Reset"
                loadingText="Sending Email"
                successText="Sent"
                failureText="Problem Resetting Password"
                ></ButtonWithLoading>
            </form>
            <div v-if="errorMessage" class="errorMessage alert alert-warning">
                {{errorMessage}}
            </div>
            <div class="successMessage alert alert-success" v-if="success">
                <!-- TODO string for password reset sent -->
                If this account exists you should recieve a password reset email within the next few minutes.<br/>
                Follow the instructions in the email to reset your password.
            </div>
        </div>
        <vue-headful
            title="Forgotten Password | Cherrytree"
        />
  </div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";

import {requestPasswordReset} from "@/network/userRequests";

export default {
  name: 'ForgottenPassword',
  components: {
    ButtonWithLoading
  },
  data: () => {
      return {
          email: "", 
          errorMessage:"",
          forgottenState: null,
          success: false
      }
  },
  mounted(){
      this.email = this.$route.query.email || "" //prefill with attempted login address
  },
  methods:{
      forgottenSubmit(){
          this.forgottenState = "loading"
          let email = this.email
          requestPasswordReset({email}, success => {
              this.forgottenState = "success"
              this.success = true;
          }, err => {
            //   TODO string for error message
              this.errorMessage = "Couldn't send a password reset email for some reason, try again later or call us"
              this.forgottenState = "failure"
              setTimeout(()=>{ this.forgottenState = null}, 1000)
          })
      }
  }
}
</script>

<style lang="scss" scoped>

</style>
